export default __webpack_public_path__ + "static/media/Rolling.6e72a047.gif";